import * as React from 'react';
import { Layout } from '../components/layout';
import { Role } from '../models/role';
import { ProdutosPage } from '../pages/produtos/produtos';
import { AdminGuard } from '../guard/admin-guard';
import { CertificadosClientePage } from '../pages/certificados-cliente/certificados-cliente';
import { CertificadosErroProcessamentoPage } from '../pages/certificados-erro-processamento/certificados-erro-processamento';
import { GerarCertificadosLotePage } from '../pages/gerar-certificados-lote/gerar-certificados-lote';
import TemplatesCertificadosPage from '../pages/templates-certificados/templates-certificados';

const headerProps = {
  name: 'Chatbot EAD',
};

export const AdminRoutes = [
  {
    routePath: '/produtos',
    isExactPath: true,
    pageToRender: (
      <React.Fragment>
        <AdminGuard>
          <Layout headerProps={headerProps}>
            <ProdutosPage />
          </Layout>
        </AdminGuard>
      </React.Fragment>
    ),
  },
  {
    routePath: '/certificados-cliente',
    isExactPath: true,
    ifHaveTheseRoles: [Role.Administrador, Role.GestorNacional, Role.GestorUF],
    pageToRender: (
      <Layout headerProps={headerProps}>
        <CertificadosClientePage />
      </Layout>
    ),
    orRedirectTo: '/',
  },
  {
    routePath: '/certificados-erro-processamento',
    isExactPath: true,
    pageToRender: (
      <AdminGuard>
        <Layout headerProps={headerProps}>
          <CertificadosErroProcessamentoPage />
        </Layout>
      </AdminGuard>
    ),
    orRedirectTo: '/',
  },
  {
    routePath: '/gerar-certificados-lote',
    isExactPath: true,
    ifHaveTheseRoles: [Role.Administrador, Role.GestorNacional, Role.GestorUF],
    pageToRender: (
      <Layout headerProps={headerProps}>
        <GerarCertificadosLotePage />
      </Layout>
    ),
    orRedirectTo: '/',
  },
  {
    routePath: '/templates-certificados',
    isExactPath: true,
    pageToRender: (
      <AdminGuard>
        <Layout headerProps={headerProps}>
          <TemplatesCertificadosPage />
        </Layout>
      </AdminGuard>
    ),
  },
];
